import React from 'react'
import Link from 'gatsby-link'
import '../style/navbar.scss'
import Fade from 'react-reveal/Fade'

//Images
import LogoMono from '../images/main_mono.png'
import Logo from '../images/main.png'
import UkFlag from '../images/uk-flag.svg'

const Navbar = ({siteTitle}) => (<div className="navbar-container">
  <div className="logo-container">
    <Fade duration={3000} delay={500}>
      <img className="logo-image color" src={Logo} alt="logo"></img>
    </Fade>
  </div>
  <temp></temp>
  <button className="contact-button">
    <a href="tel:0033695335509">
    <div >NOUS CONTACTER</div>
    <div className="icon-phone phone"></div>
    </a>
  </button>
  <div className="flag-container">
    <Link to="/en/">
    <img className="flag-uk" src={UkFlag} alt="flag"></img>
    </Link>
  </div>
</div>)

export default Navbar



// WEBPACK FOOTER //
// ./src/components/navbar.js